import {makeStyles} from '@mui/styles';
import {useTheme} from "@mui/material";

const useStyles = makeStyles(() => {
    const theme = useTheme();
    return {
        tableContainer: {
            flex: 1,
            overflowY: 'auto',
        },
        stickyHeader: {
            position: 'sticky',
            top: 0,
            zIndex: 10,
            borderBottom: `1px solid ${theme.palette.divider}`,
            // borderBottom: `1px solid red`,
        },
    }
});

export default useStyles;